const app = {
  projectFallback: "Verkefni",
};

export default app;
